import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import './styles.scss'
import App from './App'
import reportWebVitals from './reportWebVitals'
import store from './app/store'
import { Provider } from 'react-redux'
import { ConfirmProvider } from 'material-ui-confirm'
import { ThemeProvider, THEME_ID as MATERIAL_THEME_ID } from '@mui/material/styles'
import { CssVarsProvider as JoyCssVarsProvider } from '@mui/joy/styles'
import theme from './theme'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
   <ThemeProvider theme={{ [MATERIAL_THEME_ID]: theme }}>
      <JoyCssVarsProvider>
   <ConfirmProvider>
      <Provider store={store}>
         <App />
      </Provider>
   </ConfirmProvider>
         </JoyCssVarsProvider>
</ThemeProvider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
